



























import { Vue, Component, Inject } from 'vue-property-decorator'
import LanguageSelector from './LanguageSelector.vue'
import UserInfos from './UserInfos.vue'
import { User } from '../store'
import { Messages } from '@/assets/langs/langs'
import { AppConfig } from '@/types/config'
import { NAV_ITEMS, canAccessNavItem } from '@/permissions'

@Component({
  components: {
    LanguageSelector,
    UserInfos
  }
})
export default class Menu extends Vue {
@Inject('config') readonly config!: AppConfig

get messages () {
  return <Messages['components']['Menu']>this.$store.getters.messages.components.Menu
}
get user (): User | null {
  return this.$store.getters.user
}

get routeName (): string | null | undefined {
  return this.$route.name
}

canAccessNavItem(name: string): boolean {
  const item = NAV_ITEMS.find((navItem) => navItem.name === name)
  return item ? canAccessNavItem(item, this.config) : false
}

goToLogin() {
  if (this.$route.name !== 'login') {
    this.$router.push({ name: 'login' })
  }
}

goToContracts() {
  if (this.$route.name !== 'contracts') {
    this.$router.push({ name: 'contracts' })
  }
}

goToUsers() {
  if (this.$route.name !== 'users') {
    this.$router.push({ name: 'users' })
  }
}

goToClusters() {
  if (this.$route.name !== 'clusters') {
    this.$router.push({ name: 'clusters' })
  }
}

goToApplicationTypes() {
  if (this.$route.name !== 'applicationTypes') {
    this.$router.push({ name: 'applicationTypes' })
  }
}

goToDevices() {
  if (this.$route.name !== 'devices') {
    this.$router.push({ name: 'devices' })
  }
}

goToSessions() {
  if (this.$route.name !== 'sessions') {
    this.$router.push({ name: 'sessions' })
  }
}

goToMosaics() {
  if (this.$route.name !== 'mosaics') {
    this.$router.push({ name: 'mosaics' })
  }
}

goToHLS() {
  if (this.$route.name !== 'hls') {
    this.$router.push({ name: 'hls' })
  }
}

goToVOD() {
  if (this.$route.name !== 'vod') {
    this.$router.push({ name: 'vod' })
  }
}

}
